import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Education } from '../../../models/customer.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { EducationService } from '../../../services/education/education.service';

@Component({
  selector: 'app-education',
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.css']
})
export class EducationComponent implements OnInit {

  addEditDialog = false;
  modalTitle = '';
  labels = {};

  constructor(
    public educationService: EducationService,
    private dataTableService: DataTableService,
    private translateService: TranslateService
    ) {
  }

  ngOnInit() {

    this.translateService.get([
      'education.add_title',
      'education.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['education.add_title'];
      this.labels['edit_title'] = res['education.edit_title'];
    });

    this.reloadList();
  }

  reloadList() {
    this.educationService.getList().subscribe();
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.educationService.educationEditing = data == null ? new Education() : data;
    this.addEditDialog = true;
  }

  closeAddDialog() {
    this.modalTitle = '';
    this.educationService.educationEditing = null;
    this.addEditDialog = false;
  }

  delete(record): void {
    this.educationService.delete(record).subscribe(() => {
      this.reloadList();
    });
  }

  educationAdded($event): void {
    this.educationService.post($event).subscribe(() => {
      this.dataTableService.get('dt_education').showDetail = false;
      this.educationService.educationEditing = null;
      this.reloadList();
      this.addEditDialog = false;
    });
  }

  educationUpdated($event): void {
    this.educationService.put($event, this.educationService.educationEditing.id).subscribe(() => {
      this.dataTableService.get('dt_education').showDetail = false;
      this.educationService.educationEditing = null;
      this.reloadList();
      this.addEditDialog = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/education/education.component.ts